import React, { useRef, useState, useEffect } from 'react';
import { ref, onChildChanged, onValue } from 'firebase/database';
import Swal from 'sweetalert2';
import uniqid from 'uniqid';
import { db, auth } from '../../config/firebase';
import { getCollections, getCollectionsComplete, getDate, setData, updateData, incrementarMensajesChat } from '../../assets/js/functions';
import orderby from 'lodash.orderby';
import Logo from '../../assets/images/chat/f10507488.svg';
import send from '../../assets/images/chat/send.svg';
import './styles.scss';
import DeleteIcon from '@mui/icons-material/Delete';
import { AiFillEye } from 'react-icons/ai';

const ADMINS_BASE = ['000000', '111'];
const NOMBRE_ADMIN = 'Staff';

export default function Chat({ idConferencia = 'dia1' }) {
  const [admins, setAdmins] = useState(ADMINS_BASE);
  const [formValue, setFormValue] = useState('');
  const [messages, setMessages] = useState([]);
  const dummy = useRef();
  const prevMessagesCount = useRef(messages.length);

  useEffect(() => {
    cargarConfigChat();
    const devRef = ref(db, 'dev');
    onChildChanged(devRef, (snapshot) => {
      if (snapshot.key === 'adminsChat') cargarConfigChat();
    });
  }, []);

  // useEffect(() => {
  //   getMessages();
  //   const dbRef = ref(db, 'chat/');
  //   onChildChanged(dbRef, getMessages);
  // }, [idConferencia]);

  useEffect(() => {
    const dbRef = ref(db, `chat/${idConferencia}`);
    const unsubscribe = onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const ordered = orderby(Object.values(data), ['idIncrement'], ['asc']);
        setMessages(ordered);
      } else {
        setMessages([]);
      }
    });
    return () => unsubscribe();
  }, [idConferencia]);

  const cargarConfigChat = async () => {
    const data = await getCollectionsComplete('dev/adminsChat');
    if (data) {
      const extra = data.split(',').map((v) => v.trim());
      setAdmins([...ADMINS_BASE, ...extra]);
    }
  };

  useEffect(() => {
    if (messages.length > prevMessagesCount.current) {
      const scrollElement = document.getElementById('main');
      scrollElement?.scroll({ top: scrollElement.scrollHeight, behavior: 'smooth' });
    }
    prevMessagesCount.current = messages.length;
  }, [messages]);

  const getMessages = async () => {
    const dataMessages = await getCollections(`chat/${idConferencia}`);
    const orderedMessages = orderby(dataMessages, ['idIncrement'], ['asc']);
    setMessages(orderedMessages);
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    const uid = auth.currentUser?.uid;
    if (!uid || !formValue.trim()) return;

    const userData = await getCollectionsComplete(`usuarios/${uid}`);
    const id = uniqid();
    const json = {
      id,
      idIncrement: messages.length + 1,
      text: formValue,
      visible: true,
      fechaDeRegistro: getDate(),
      user: uid,
      nombre: userData?.nombre || 'Usuario',
    };
    setMessages([...messages, json]);
    setData(`chat/${idConferencia}`, id, json);
    incrementarMensajesChat();
    setFormValue('');
  };

  const vetarUsuario = async (idUser) => {
    const result = await Swal.fire({
      title: '¿Deseas borrar mensajes de este usuario?',
      icon: 'warning',
      confirmButtonText: 'Confirmar',
      confirmButtonColor: '#E9010B',
      showCancelButton: true,
      cancelButtonText: 'cerrar',
    });
    if (result.isConfirmed) {
      const dataMessages = await getCollections(`chat/${idConferencia}`);
      const json = {};
      const orderedArray = Object.values(dataMessages).map((val) => {
        if (val.user === idUser) {
          json[val.id] = { ...val, visible: false };
          return { ...val, visible: false };
        } else {
          json[val.id] = { ...val };
          return val;
        }
      });
      setData('chat', idConferencia, json);
      setMessages(orderby(orderedArray, ['idIncrement'], ['asc']));
    }
  };

  const ChatMessage = ({ message }) => {
    const { text, user, fechaDeRegistro, nombre, visible, id } = message;
    const isAdmin = admins.includes(user);
    const uid = auth.currentUser?.uid;
    const enableDelete = admins.includes(uid);
    const displayName = isAdmin ? NOMBRE_ADMIN : nombre;
    const imgMessage = isAdmin ? Logo : `https://ui-avatars.com/api/?name=${encodeURIComponent(nombre)}&background=random`;

    const vetarMessage = () => {
      const json = { ...message, visible: !visible };
      Swal.fire({
        title: '¿Deseas borrar el mensaje?',
        icon: 'warning',
        confirmButtonText: 'Confirmar',
        confirmButtonColor: '#E9010B',
        showCancelButton: true,
        cancelButtonText: 'cerrar',
      }).then((result) => {
        if (result.isConfirmed) {
          updateData(`chat/${idConferencia}`, id, json);
          setMessages((prev) => prev.map((msg) => (msg.id === id ? { ...msg, visible: !visible } : msg)));
        }
      });
    };

    return (
      <div style={{ display: visible ? 'block' : 'none' }}>
        <span className='fecha'>{fechaDeRegistro}</span>
        <div className={`message ${isAdmin ? 'sent' : 'received'}`}>
          <img className='hijos' src={imgMessage} alt='User' />
          <p>
            <span className='bold'>
              {displayName}
              <br />
            </span>
            {text}
          </p>

          {enableDelete && (
            <div className='cursor' onClick={vetarMessage}>
              <DeleteIcon className='btn-delete' />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div id='chat'>
      <div className='App'>
        <section>
          <div className='titulo-chat'>
            <div>Chat</div>
          </div>
          <main id='main' ref={dummy}>
            {messages.map((msg) => (
              <ChatMessage key={msg.id} message={msg} />
            ))}
          </main>
          <form onSubmit={sendMessage}>
            <input value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder='Escribe un mensaje...' />
            <button type='submit' disabled={!formValue}>
              <img src={send} alt='send' className='botonSubmit' />
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}
